import Quiz from "./quiz/quiz.js";

window.initDom = ($wrapper) => {
    $wrapper.querySelectorAll('[data-quiz]').forEach($element => new Quiz($element));
}

(function() {
    window.initDom(document);
})();